var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-circle-notch fa-spin fa-3x"})]),_c('div',{staticClass:"text text-center mt-3"},[_c('h4',[_vm._v("Wczytywanie - proszę czekaj...")])])])
}]

export { render, staticRenderFns }